var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveQuickLinks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9965C10.6583 14.6684 11.5594 15.047 12.5 15.047C13.4406 15.047 14.3417 14.6684 15 13.9965L19 9.99647C20.3807 8.61576 20.3807 6.37718 19 4.99647C17.6193 3.61576 15.3807 3.61576 14 4.99647L13.5 5.49647",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 10.0036C13.3421 9.33175 12.441 8.95312 11.5004 8.95312C10.5597 8.95312 9.65869 9.33175 9.00038 10.0036L5.00038 14.0036C3.61967 15.3843 3.61967 17.6229 5.00038 19.0036C6.38109 20.3843 8.61967 20.3843 10.0004 19.0036L10.5004 18.5036",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveQuickLinks);
export default __webpack_public_path__ + "static/media/active-quick-links.9a18224cf76c4a47ea7878c3dfa3b810.svg";
export { ForwardRef as ReactComponent };